let pendingFocusId: string | number | null = null;
let pendingFrame: number | null = null;

const MAX_ATTEMPTS = 120; // ~2s at 60fps

const findRealFocusableElement = (focusId: string | number): HTMLElement | null => {
  const escapedId = CSS.escape(`${focusId}`);
  const scope = document.querySelector(
    `[data-fcsid="${escapedId}"]`,
  ) as HTMLElement | null;
  if (!scope) return null;

  return scope.querySelector('button');
};

const isOnScreen = (el: HTMLElement): boolean => {
  const rect = el.getBoundingClientRect();
  return (
    rect.width > 0 &&
    rect.height > 0 &&
    rect.left >= 0 &&
    rect.right <= window.innerWidth &&
    rect.top >= 0 &&
    rect.bottom <= window.innerHeight
  );
};

export const cancelPendingRealFocusSync = (): void => {
  if (pendingFrame !== null) {
    cancelAnimationFrame(pendingFrame);
    pendingFrame = null;
  }
  pendingFocusId = null;
};

export const syncRealFocusOnVega = (
  focusId: string | number | null | undefined,
  attemptsRemaining: number = MAX_ATTEMPTS,
): void => {
  if (!focusId) return;

  pendingFocusId = focusId;

  const attemptFocus = () => {
    try {
      if (pendingFocusId !== focusId || attemptsRemaining <= 0) {
        return;
      }

      const el = findRealFocusableElement(focusId);

      if (el && isOnScreen(el)) {
        el.focus({ preventScroll: true });
        pendingFocusId = null;
        return;
      }

      pendingFrame = requestAnimationFrame(() => {
        syncRealFocusOnVega(focusId, attemptsRemaining - 1);
      });
    } catch (err) {
      console.error('[realFocusSync] threw for focusId:', focusId, err);
      pendingFocusId = null;
    }
  };

  attemptFocus();
};
